import { openedModelToStatePatch } from 'Pods/ThreeDStudio/Services/openedModelToStatePatch/openedModelToStatePatch'
import { DEFAULT_MODEL_SETTINGS } from 'Pods/ThreeDStudio/Store/constants'

const EMPTY_SETTINGS = {}

let lastOpenedModel
let lastSettings = EMPTY_SETTINGS

const deriveSettings = (openedModel) => {
  const patch = openedModelToStatePatch(openedModel)
  const isEmpty = !patch.openedModel || Object.keys(patch.openedModel).length === 0

  if (isEmpty) {
    return EMPTY_SETTINGS
  }

  const { material, targetPolycount, polygonType, isSmartLowPoly } = {
    ...DEFAULT_MODEL_SETTINGS,
    ...(patch.modelSettings || {}),
  }

  return {
    // Enhancement runs (retexture, mesh simplification/segmentation) carry the
    // provider that produced the displayed mesh as enhancedProvider instead.
    generationProvider: patch.schema?.generationProvider ?? patch.schema?.enhancedProvider,
    material,
    targetPolycount,
    polygonType,
    isSmartLowPoly,
  }
}

/**
 * Selects the generation settings that produced the opened model (library run)
 * by re-running openedModelToStatePatch on ui.openedModel, mirroring how
 * setOpenedModel seeds the modelSettings / schema slices. Deriving from the
 * immutable openedModel instead of reading those live slices keeps consumers
 * (e.g. the viewport ModelDetailsCard) fixed on the settings the displayed
 * model was generated with while the user edits the generation panel.
 *
 * Memoized on the openedModel reference so the selector returns a stable
 * object between renders, as zustand requires.
 *
 * @param {Object} state - ThreeDStudio store state
 * @returns {Object} - { generationProvider, material, targetPolycount,
 * polygonType, isSmartLowPoly }, or {} when no parseable model is open
 */
export const selectOpenedModelGenerationSettings = (state) => {
  const openedModel = state.ui?.openedModel

  if (openedModel !== lastOpenedModel) {
    lastOpenedModel = openedModel
    lastSettings = deriveSettings(openedModel)
  }

  return lastSettings
}
